import * as ApiHelpers from './api_helper';

const apiRoute = 'apps';

export const AppRepository = {
  GetApp: id => ApiHelpers.api_call_get(`${apiRoute}/${id}`),
  GetListApp: (filter) => ApiHelpers.api_call_post(`${apiRoute}/filter`, filter),
  PutApproveApp: data => ApiHelpers.api_call_put(apiRoute, data),
  PutPublishedApp: (id, data) => ApiHelpers.api_call_put(`${apiRoute}/${id}/published`, data)
};
